import { AnyAction } from 'redux';
import { ActionType, createReducer } from 'typesafe-actions';
import { BrandingState } from './types';

export const createBrandingReducer = (initialState: BrandingState) =>
  createReducer<BrandingState, ActionType<AnyAction>>(initialState);
